import { Dispatch, SetStateAction } from 'react';
import { MOStep1 } from './MOFormSteps/MOStep1';
import { MOStep2 } from './MOFormSteps/MOStep2';
import { MOStep3 } from './MOFormSteps/MOStep3';
import { MOStep4 } from './MOFormSteps/MOStep4';
import { MOStep5 } from './MOFormSteps/MOStep5';
import { MONonUK } from './MOFormSteps/MONonUK';
import { MONonUKNoVAT } from './MOFormSteps/MONonUKNoVAT';

type MembershipOptionsProps = {
  membershipQuestions: any;
	setMembershipQuestions: Dispatch<any>;
  setMembershipResultList: Dispatch<any>;
  setCurrentStep: Dispatch<SetStateAction<number | string>>;
  currentStep: number | string;
  setMembershipQErr: Dispatch<SetStateAction<boolean>>;
};

export const MOIntegration: React.FC<MembershipOptionsProps> = ({
  membershipQuestions,
	setMembershipQuestions,
  setMembershipResultList,
  setCurrentStep,
  currentStep,
  setMembershipQErr
}) => {
  const currentStepPage = () => {
    switch(currentStep) {
      case 1:
        return (
          <MOStep1 
            setCurrentStep={setCurrentStep}
						membershipQuestions={membershipQuestions}
						setMembershipQuestions={setMembershipQuestions}
          />
        );
      case "NonUK":
        return (
          <MONonUK 
            setCurrentStep={setCurrentStep}
						membershipQuestions={membershipQuestions}
						setMembershipQuestions={setMembershipQuestions}
            setMembershipQErr={setMembershipQErr}
          />
        );
      case "NonUKNoVAT":
        return (
          <MONonUKNoVAT
            setCurrentStep={setCurrentStep}
            membershipQuestions={membershipQuestions}
            setMembershipQuestions={setMembershipQuestions}
          />
        );
      case 2:
        return (
          <MOStep2 
            setCurrentStep={setCurrentStep}
						membershipQuestions={membershipQuestions}
						setMembershipQuestions={setMembershipQuestions}
          />
        );
      case 3:
        return (
          <MOStep3 
            setCurrentStep={setCurrentStep}
						membershipQuestions={membershipQuestions}
						setMembershipQuestions={setMembershipQuestions}
          />
        );
      case 4:
        return (
          <MOStep4 
            setCurrentStep={setCurrentStep}
						membershipQuestions={membershipQuestions}
						setMembershipQuestions={setMembershipQuestions}
          />
        );
      case 5:
        return (
          <MOStep5 
            setCurrentStep={setCurrentStep}
						membershipQuestions={membershipQuestions}
						setMembershipQuestions={setMembershipQuestions}
						setMembershipResultList={setMembershipResultList}
          />
        );				
      default:
        return null;
    } 
  };

  return (
    <>
      {currentStepPage()}
    </>
  );
};